import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { CcenterService } from '../services';
import { Ccenter } from '../models';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CostCenterResolver implements Resolve<Ccenter[]> {
  searchBy :string = null;
  ccenters: Ccenter[];

  constructor(private readonly ccenterService: CcenterService) {}  

  resolve(route: ActivatedRouteSnapshot) : Observable<Ccenter[]> {
    const rangeCriteria = route.params.range != null ? route.params.range : route.data.range;
    const searchCriteria = route.params.searchBy;
    const orderByNumber = true;
    
    if(rangeCriteria == null) return of(null);

    return this.ccenterService.getCcenter(rangeCriteria, searchCriteria, orderByNumber);
  }
}